import { v4 as uuidv4 } from 'uuid';

export const onImgLoad = (
    el: HTMLElement,
    onLoad: () => void,
    onToggleLoadingImg: (id: string) => void,
) => {
    if (!el) return () => {};
    let ids: string[] = [];
    const images = Array.from(el.querySelectorAll('img'));
    images.forEach(img => {
        const id = uuidv4();
        ids.push(id);
        onToggleLoadingImg(id);
        img.addEventListener('load', () => {
            onLoad();
            onToggleLoadingImg(id);
            ids = ids.filter(item => item !== id);
        });
        img.addEventListener('error', () => {
            onLoad();
            onToggleLoadingImg(id);
            ids = ids.filter(item => item !== id);
        });
    });

    return () => {
        images.forEach(img => {
            img.removeEventListener('load', onLoad);
            img.removeEventListener('error', onLoad);
        });
        ids.forEach((id) => onToggleLoadingImg(id));
    };
};
